/** @jsx jsx */
import { array, bool, func, string } from 'prop-types'
import { Flex, Text, jsx } from 'theme-ui'
import QuestionSection from '../../common/QuestionSection'

const Beside = ({ questions, ...rest }) => {
  return (
    <Flex
      as="section"
      sx={{
        flexDirection: 'column',
        mt: '50px',
      }}
    >
      <Text
        variant="mediumText"
        sx={{
          fontWeight: 'normal',
          color: 'black',
          fontSize: 3,
          ml: '32px',
        }}
      >
        {questions[0].text}
      </Text>
      <Flex
        sx={{
          alignItems: 'center',
          gap: '60px',
        }}
      >
        {questions.map(question => (
          <QuestionSection
            key={question.id}
            question={question}
            {...rest}
            hideTitle
            sx={{
              position: 'relative',
              width: 'auto',
              '.subText': {
                m: 0,
              },
              '&:first-of-type': {
                '&:after': {
                  content: '" "',
                  display: 'block',
                  width: '1px',
                  height: '100%',
                  backgroundColor: 'medSilver',
                  position: 'absolute',
                  top: 0,
                  right: '-60px',
                },
              },
            }}
          />
        ))}
      </Flex>
    </Flex>
  )
}

Beside.propTypes = {
  type: string,
  questions: array.isRequired,
  questionHasTooManyAnswers: bool,
  setQuestionHasTooManyAnswers: func,
}

export default Beside
